module.exports = __webpack_public_path__ + "img/ic_bold.d73b3996.svg";